<template>
    <div>
        <div class="group-head">
            <div class="title"><span class="el-icon-data-line"></span> 每日</div>
            <div class="sub-title color-danger">（以下展示销售数据）</div>
        </div>
        <div class="content MT20" v-loading="dataLoading">
           <div id="chartContainer1" ref="chartContainer1"></div>
        </div>
    </div>
</template>
<script>
import { Chart } from '@antv/g2';
export default {
    props:{
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            data: [],
            dataLoading: false,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        daterange(v1,v2){
            if(v2.length > 0 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/activitySales2",
                method: "POST",
                data: {
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || [];
                        this.$nextTick(() => {
                            this.drawChart();
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drawChart(){
            if( this.chart ) this.chart.destroy();
            
            let _data = [...this.data];
            _data.map(v => {
                v.value = parseFloat(v.value)
            })

            this.chart = new Chart({
                container: 'chartContainer1',
                autoFit: true,
                height: 300,
            });
            this.chart.data(_data);

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
                itemTpl: '<div><div class="g2-tooltip-title" style="font-size:14px;font-weight:700;">{name}：{value}</div><ul class="g2-tooltip-list">{rank}</ul></div>',
            });
            
            if( _data.length > 30 ){
                this.chart.option('slider', {
                    start: (_data.length - 30) / _data.length,
                    end: 1,
                });
            }
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value*rank', (name,value,rank) => {
                    
                    let _rank = ""
                    if( rank && rank.length > 0 ){
                        rank.map(v => {
                            _rank += `<li class="g2-tooltip-list-item"><span class="g2-tooltip-name">${v.name}</span>：<span class="g2-tooltip-value">${v.value}</span></li>`
                        })
                    }

                    return {
                        name: name,
                        value: value.toFixed(2),
                        rank: _rank
                    };
                });

            this.chart.render();
            
        }
    }
}
</script>
<style lang="scss" scoped>

</style>